import React, { useEffect, useRef } from "react";
import CustomLoader from "../Loader";
import { Modal } from "bootstrap";
import loaderimg from '../../../../assets/svg/loader.svg';
import inmatelogo from '../../../../assets/svg/inmate-logo.svg'

const CommonModal = ({
  modalId,
  title,
  loader,
  bodyContent,
  footerContent,
  handleCloseIcon,
  showCloseIcon = true,
  closeModalTrigger = false,
  modalSize = "modal-xl",
}) => {
  const modalRef = useRef(null);

  useEffect(() => {
    if (closeModalTrigger) {
      const modalElement = modalRef.current;
      if (modalElement) {
        const modalInstance =
          Modal.getInstance(modalElement) || new Modal(modalElement);
        modalInstance.hide();
      }
    }
  }, [closeModalTrigger]);

  return (
    <>
      <div
        className="modal fade"
        id={modalId}
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        ref={modalRef}
      >
        {/* <div className="modal-dialog modal-xl"> */}
        <div className={`modal-dialog ${modalSize}`}>
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">{title}</h4>
              {showCloseIcon && (
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-hidden="true"
                  onClick={handleCloseIcon}
                ></button>
              )}
            </div>
            <div className="modal-body">
              {loader ?
                <div className="modalcol-bg"> <div className="modalcol-loader">
                  <img src={loaderimg} alt="Loading..." className="modalcol-loader-03" />
                  <img src={inmatelogo} alt="Inmate Logo" className="modalcol-loader-image" />
                </div> </div>
                : bodyContent}
            </div>
            <div className="modal-footer">
              {
                footerContent
                // || (
                //   <a href="#/" className="btn btn-white" data-bs-dismiss="modal">
                //     Close
                //   </a>
                // )
              }
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CommonModal;
